import {useIsGuestSession} from '@sollapay/web-core';

import {FeatureFlag, useFeatureFlag} from '@/features/feature-flags';
import {useCurrentTrustAccount, useTrustTypeStrategy} from '@/features/trust-accounts/providers';

/**
 * Payouts also require the `payouts_tab` flag on top of the trust type's own support for it. A
 * guest reads the flag of the firm that owns this account, as they may hold accounts of several firms.
 */
export function useShowsPayoutsTab(): boolean {
  const {showsPayoutsTab} = useTrustTypeStrategy();
  const {id} = useCurrentTrustAccount();
  const isGuest = useIsGuestSession();
  const payoutsTabFlagEnabled = useFeatureFlag(FeatureFlag.PAYOUTS_TAB, isGuest ? id : undefined);
  return showsPayoutsTab && payoutsTabFlagEnabled;
}
